// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Baustelle, BaustelleDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateBaustelle(): (
  requestBody: BaustelleDaten
) => Promise<Baustelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).baustellen.createBaustelle({ requestBody }),
    [getAPI]
  );
}
